import { ButtonBase } from '@fukku/button/Base/ButtonBase'
import textActionM from '@fukku/styles/texts/textActionM.module.css'
import { cx } from 'classix'
import styles from '../OverlayButton.module.css'
import type { OverlayButtonIconProps } from '../types'

export const IconOverlayButton = (props: OverlayButtonIconProps) => {
	const { className, children, variant, icon, ...rest } = props

	return (
		<ButtonBase
			{...rest}
			className={cx(
				className,
				styles.overlayButton,
				styles[variant],
				textActionM.className
			)}
		>
			{children && <span className={styles.content}>{children}</span>}
			<span className={styles.icon}>{icon}</span>
		</ButtonBase>
	)
}
